import { Injectable } from "@angular/core"

@Injectable({
  providedIn: 'root'
})
export class EditspaceService {

  isEditspace(): boolean {
    return window.location.hostname.includes("editspace")
  }
}
